import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  AdminProtectedRoute,
  CommonProtectedRoutes,
  SupervisorProtectedRoute,
} from './utils/validators/ProtectedRoute';
import { IndexAdmin } from './routes/IndexAdmin';
import { IndexSupervisor } from './routes/IndexSupervisor';
import ErrorPage from './error-page';
import Login from './pages/login/Login';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { IndexCommon } from './routes/IndexCommon';

//mendatory setting for adding color in palette
declare module '@mui/material/styles' {
  interface PaletteOptions {
    blueButton: PaletteOptions['primary'];
    greenButton: PaletteOptions['primary'];
    // Button: PaletteOptions["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: '#c80202',
    },
    secondary: {
      main: '#212529',
    },
    error: {
      main: '#f44336',
    },
    warning: {
      main: '#ff9800',
    },
    text: {
      // primary: '#111',
      // secondary: '#f1f3f5',
    },
    blueButton: {
      main: '#003566',
      contrastText: '#fff',
    },
    greenButton: {
      main: '#064a29',
      contrastText: '#fff',
    },
  },
  typography: {
    // fontFamily: 'Raleway, Arial',
    fontSize: 22,
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />,
    errorElement: <ErrorPage />,
  },
  {
    path: '/admin',
    element: <AdminProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [...IndexAdmin],
  },
  {
    path: '/supervisor',
    element: <SupervisorProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [...IndexSupervisor],
  },
  {
    path: '/common',
    element: <CommonProtectedRoutes />,
    errorElement: <ErrorPage />,
    children: [...IndexCommon],
  },
]);

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <RouterProvider router={router} />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default App;
